import ajax from '@/utils/ajax'

/**
 * @module 会员营销
 */

/**
 * 任务列表
*/

// 会员任务列表-列表查询接口
export const taskList = params => ajax.post('/marketTask/taskList', params)

// 会员任务列表-枚举接口
// export const targetList = params => ajax.post('/portrayal/targetList', params)

// 会员任务列表-取消任务接口
export const updateStatusById = params => ajax.post('marketTask/updateStatusById', params)

// 会员任务列表-详情接口
// export const taskDetail = params => ajax.post('marketTask/taskDetail', params)

// 用户推荐画像
export const recommendPortrayal = params => ajax.post('portrayal/recommendPortrayal', params)

// 用户推荐画像
export const groupAndChildPortrayal = params => ajax.post('portrayal/groupAndChildPortrayal', params)

// 用户推荐画像
export const taskDetail = params => ajax.post('marketTask/taskDetail', params)

// 用户推荐画像
export const targetList = params => ajax.post('portrayal/targetList', params)

/*****
 * 
 * 会员看板
 * 
 */
// 我的会员
export const getMemberData = params => ajax.post('starlink/refuelingMembers/myMembers', params)

// 数据趋势
export const getMemberTrend = params => ajax.post('starlink/refuelingMembers/myDataTrend', params)

// // 提醒类型
export const alertType = params => ajax.post('activity/alertType', params)
